<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <unit-form
          @submit="submit"
          :init-unit="{}"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import UnitForm from './unit-form'

export default {
  components: { UnitForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (unit) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('units', unit).then(({ data }) => {
        this.$notify({
          message: 'Einheit erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/units')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  }
}
</script>

<style>
</style>
